query GetCalendarSyncForActivityModal {
    loggedInUser {
        id
        calendarSync {
            isEnabled
            externalService
            primaryCalendar {
                exportRule
            }
        }
    }
}
